import { gql } from '@apollo/client';

export const GET_TWITTER_FUNDING_INSTRUMENT = gql`
  query GetList($request: TwitterFundingInstrumentRequest!) {
    GetListTwitterFundingInstrument(request: $request) {
      total_count
      next_cursor
      data
    }
  }
`;

export const GET_TWITTER_FUNDING_INSTRUMENT_BY_ID = gql`
  query GetByID($request: TwitterFundingInstrumentRequest!) {
    list: GetTwitterFundingInstrument(request: $request) {
      data
    }
  }
`;
